// Typelizer digest a788f1cd0c98cd0bf533c4ab0a1e049c
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/ledger/payments */
  index: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/payments', {}, options),
    method: 'get',
  }),

  /** GET /c/:company_id/ledger/payments/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/payments/:id', params, options),
    method: 'get',
  }),
}
